import { createAsyncThunk } from '@reduxjs/toolkit';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../../../firebaseConfig';
import { getErrorMessage } from '../utils.js';

// Check if email already exists on waitlist
export const checkEmailExists = createAsyncThunk(
  'waitlist/checkEmail',
  async (email, { rejectWithValue }) => {
    try {
      const waitlistRef = collection(db, 'waitlist_entries');
      const q = query(waitlistRef, where('email', '==', email.toLowerCase()));
      const querySnapshot = await getDocs(q);

      return !querySnapshot.empty;
    } catch (error) {
      console.error('Error checking email:', error);
      return rejectWithValue(getErrorMessage(error));
    }
  }
);
